<template>
    <DesignRequest></DesignRequest>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const DesignRequest = defineAsyncComponent(() =>
    import("../../components/ProjectManagement/DesignRequest/DesignRequest.vue")
);

export default {
    name: "DesignRequestForm", //The name you are in should not equal the name of the component you are importing.
    components: { DesignRequest, AuthLayout },
};
</script>
